export const formatEmptyJson = (input: string): string => {
  const cleanedInput = input.replace(/\s/g, "");

  // If the cleaned input is an empty object, return a properly formatted empty object
  if (cleanedInput === "{}") return "{}";

  // Otherwise, return the original input (or you could throw an error if input is invalid)
  return input;
};
